<template>
	
	<div class="vpay__editable-block">
		
		<slot v-if="!editable" name="display">
			
		</slot>
		
		<slot v-if="editable" name="editable">
			
		</slot>
		
		<slot v-if="showButton" name="button">
			<el-button class="vpay__editable-block-edit-button" type="text" size="mini" :icon="editButtonIcon" @click="onClickEditButton">{{ editButtonTitle }}</el-button>
		</slot>
		
	</div>
	
</template>

<script>
	
	export default {
		
		name: "EditableBlock",
		
		props: {
			
			mode: { default: "display", type: String },
			
			showButton: { default: true, type: Boolean },
			
			showEditableState: { default: true, type: Boolean },
			
		},
		
		computed: {
			
			editButtonIcon() {
				return this.editable ? "el-icon-check" : "el-icon-edit";
			},
			
			editButtonTitle() {
				return this.editable ? "Save" : "Edit";
			}
			
		},
		
		methods: {
			
			onClickCancelButton() {
				this.editable = false;
				this.$emit("event", { name: "cancel", trigger: "click", "source": this });
			},
			
			onClickEditButton() {
				if (this.showEditableState) {
					if (this.editable) {
						this.editable = false;
						this.$emit("event", { name: "save", trigger: "click", "source": this });
					} else {
						this.editable = true;
						this.$emit("event", { name: "edit", trigger: "click", "source": this });
					}
				} else {
					this.$emit("event", { name: "edit", trigger: "click", "source": this });
				}
			}
			
		},
		
		data() {
			
			return {
				//saving: false,
			 	editable: this.mode === "edit",
			};
			
		},
		
	}
	
</script>

<style>
	
	
	
</style>
